(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["psc-products"] && !Shopify.designMode) return;
  try {
    
  window.pscAddToCart = async function (ids) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
    const settings = window.MinimogSettings || {};
    const drawer = document.querySelector('m-cart-drawer');
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'pre-summer-checklist' });
    }
    // Upcart is the store's cart. It opens itself on /cart/add.js, so never open the Minimog drawer as well (two stacked carts).
    if (typeof window.upcartOpenCart === 'function') {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      window.upcartOpenCart();
    } else if (settings.enable_cart_drawer && drawer && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
      drawer.open();
    } else {
      window.location.href = (settings.routes && settings.routes.cart) || root + 'cart';
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-psc-card]');
    if (!form) return;
    event.preventDefault();
    const btn = form.querySelector('.psc-add');
    const msg = form.querySelector('.psc-msg');
    const ids = [...form.querySelectorAll('[name="psc-id"]')].map((el) => el.value);
    if (ids.some((id) => !id)) { msg.textContent = 'Choose a size first.'; return; }
    btn.disabled = true;
    msg.textContent = '';
    try { await window.pscAddToCart(ids); } catch (err) { msg.textContent = err.message; } finally { btn.disabled = false; }
  });

  } catch(e) { console.error(e); }
})();
})();
